<div *ngIf="canSendPrenoteFile()">
<div class="nav-bar">
  <div class="nav-panel">
    <div class="header-position">
      <ukg-label class="nav-bar-text" type="tertiary" translate data-automation="company_info_selected_items_count"
        [translateParams]="{ selectedCount: selectedCompanyCount }">
        COMMON.SELECTED_ITEMS_COUNT
      </ukg-label>
    </div>
    <div class="header-position">
      <div>
        <ukg-button (click)="sendPrenoteFile()" data-automation="company_info_send_prenote_file_btn"
          [attr.aria-disabled]="!areAnyCompanySelected() || isSendingPrenote" [disabled]="!areAnyCompanySelected() || isSendingPrenote"
          translate emphasis="low" size="medium" parent-icon="send"> COMPANIES.SEND_PRENOTE_FILE_BTN
        </ukg-button>
      </div>
    </div>
    <div class="header-position header-position-right">
      <div>
        <ukg-button (click)="viewHistory()" data-automation="company_info_send_view_history_btn"
          translate emphasis="low" size="medium" parent-icon="document"> COMPANIES.VIEW_PRENOTE_HISTORY_BTN
        </ukg-button>
      </div>
    </div>
  </div>
  <div>
    <div class="header-position">
      <div class="filter-position">
        <ssg-company-info-filters (toggle)="showFilters=$event" style="height: 100%"
          class="flex-1-0-auto" [isWorking]="isSendingPrenote">
        </ssg-company-info-filters>
      </div>
    </div>
  </div>
</div>
<div class="display-notification">
  <ssg-notification-bar [userMessages]="userMessages" [notification]="notificationSubject.asObservable()"
    pageKey="company-info-table" #companyInfoTableNotificationBar>
  </ssg-notification-bar>
</div>

<div style="position: relative;" class="datatable-position">
  <div [ngClass]="{'table-with-filters-container-on': showFilters, 'table-with-filters-container-off': !showFilters }">
    <div class="table-container flex-100">

      <ukg-data-table-container>
        <ukg-data-table [columnNames]="allColumns" (ukgDataTableSortChanged)="handleSort($event)" data-automation="company-info-table">
          <table id="table">
            <thead id="head">
              <tr>
                <ng-container data-automation="company-info-table-column-companySelected">
                  <ukg-th style="width:2%" data-automation="company-info-table-header-companySelected">
                    <div class="checkbox">
                      <label for="select-all-companies" translate>
                        <input type="checkbox" id="select-all-companies"
                          data-automation="company-info-table-header-companySelected-checkbox" [checked]="areAllCompaniesSelected()"
                          [indeterminate]="!areAllCompaniesSelected() && areAnyCompanySelected()"
                          (click)="clickAllCompanies($event.target.checked)" />
                      </label>
                    </div>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="company-info-table-column-legalName">
                  <ukg-th style="width:18%" data-automation="company-info-table-header-legalName" sort-key="legalName"
                    sortable initial-sort-direction="asc">
                    <span data-automation="company-info-table-header-legalName-label" translate>
                      COMPANIES.COLUMN_COMPANY</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="company-info-table-column-companyCode">
                  <ukg-th style="width:5%" data-automation="company-info-table-header-companyCode"
                    sort-key="companyCode" sortable>
                    <span data-automation="company-info-table-header-companyCode-label" translate>
                      COMPANIES.COLUMN_COMPANY_CODE
                    </span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="company-info-table-column-fein">
                  <ukg-th style="width:7%" data-automation="company-info-table-header-fein"
                    sort-key="fein" sortable>
                    <span data-automation="company-info-table-header-fein-label"
                      translate>COMPANIES.COLUMN_FEIN</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="company-info-table-column-payGroups">
                  <ukg-th style="width:22%" data-automation="company-info-table-header-payGroups"
                    sort-key="payGroups" sortable>
                    <span data-automation="company-info-table-header-payGroups-label"
                      translate>COMPANIES.COLUMN_PAY_GROUPS</span>
                  </ukg-th>
                </ng-container>
                <ng-container data-automation="company-info-table-column-lastPrenoteFileSent">
                  <ukg-th style="width:8%" data-automation="company-info-table-header-lastPrenoteFileSent"
                    sort-key="lastPrenoteFileSent" sortable>
                    <span data-automation="company-info-table-header-lastPrenoteFileSent-label"
                      translate>COMPANIES.COLUMN_PRENOTE_FILE_LAST_SENT
                    </span>                   
                  </ukg-th>
                </ng-container>
              </tr>
            </thead>
            <tbody data-automation="data-table-body">
              <ng-container *ngFor="let company of records; let i = index">
                <tr data-automation="company-info-table-row">
                  <td class="check-cell"
                    data-automation="company-info-table-row-companySelected">
                    <div class="checkbox">
                      <label for="{{ company.companyId }}" translate>
                        <input data-automation="company-info-table-row-companySelected-checkbox" type="checkbox"
                          id="{{ company.companyId }}" [checked]="isCompanySelected(company)"
                          (click)="clickCompany(company, $event.target.checked)" />
                      </label>
                    </div>
                  </td>
                  <td
                    data-automation="company-info-table-row-legalName">
                    <span data-automation="company-info-table-row-legalName-content" >
                        {{company.legalName | truncate:40}}
                    </span>
                  </td>
                  <td
                    data-automation="company-info-table-row-companyCode">
                    <span data-automation="company-info-table-row-companyCode-content" >
                        {{company.companyCode | truncate:30}}
                    </span>
                  </td>
                  <td
                    data-automation="company-info-table-row-fein">
                    <span data-automation="company-info-table-row-fein-content" >
                        {{company.fein | formatfein}}
                    </span>
                  </td>
                  <td
                    data-automation="company-info-table-row-payGroups">
                    <span data-automation="company-info-table-row-payGroups-content" >
                        {{ company.payGroups | truncate:300 }}
                    </span>
                  </td>
                  <td
                    data-automation="company-info-table-row-prenoteFileSent">
                    <span *ngIf="!(company.lastPrenoteFileSent | isMinDate)" 
                    data-automation="company-info-table-row-prenoteFileSent-content"
                    (mouseenter)="requestedFromPSGDisplayName.present($event.target)"
                    (mouseleave)="requestedFromPSGDisplayName.dismiss()" >
                      {{company.lastPrenoteFileSent | ultishortdate: 'L'}}
                    </span>
                    <ukg-popover #requestedFromPSGDisplayName position="top">{{getRequestedFromKey(company.requestedFromPSGFlag) | translate }}</ukg-popover>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </ukg-data-table>
        <ukg-paginator id="paginator" data-automation="paginator" (ukgPageChanged)="onPaginatorChanged($event)"
          [rowsPerPage]="initialRowsPerPage" [totalItems]="dataCount" [rowsOptions]="rowsOptions" translate>
        </ukg-paginator>
      </ukg-data-table-container>
    </div>
  </div>
</div>
</div>


<ukg-modal #sendPrenoteResultsModal autoScroll data-automation="modal-action-results">
  <div *ngIf="isSendingPrenote; else sendPrenoteResults">
  </div>
  <ng-template #sendPrenoteResults>
    <div class="modal-display-header">
      <h3 class="modal-title" id="confirmation-title" translate>COMPANIES.SEND_PRENOTE_RESULT_POPUP_TITLE</h3>
      <ukg-button (click)="sendPrenoteResultsModal.dismiss()" parent-icon="close" class="modal-close-icon" type="text"
        [attr.aria-label]="'COMMON.BUTTON_CLOSE' | translate" icon-only>
      </ukg-button>
    </div>
    <div class="modal-display-body">
      <span data-automation="send-prenote-result-message" translate>
        COMPANIES.SEND_PRENOTE_RESULT_MESSAGE
      </span>
    </div>
    <div class="modal-display-footer">
      <ukg-button data-automation="send-prenote-result-done" (click)="sendPrenoteResultsModal.dismiss()" translate>
        COMMON.BUTTON_DONE
      </ukg-button>
    </div>
  </ng-template>
</ukg-modal>

<ukg-modal #sendPrenoteConfirmationModal autoScroll data-automation="modal-send-prenote-confirmation">
  <div *ngIf="isSendingPrenote; else sendPrenoteContent">
  </div>
  <ng-template #sendPrenoteContent>
    <div class="modal-display-header">      
      <h3 class="modal-title" translate>
        COMPANIES.SEND_PRENOTE_CONFIRMATION_TITLE</h3>
      <ukg-button parent-icon="close" class="modal-close-icon" type="text"
        [attr.aria-label]="'COMMON.BUTTON_CLOSE' | translate" (click)="sendPrenoteConfirmationModal.dismiss()" icon-only>
      </ukg-button>
    </div>
    <div class="modal-display-body">
      <span translate data-automation="send-prenote-message"
      [translateParams]="{companyNo : _selectedCompanyCount}">
      COMPANIES.SEND_PRENOTE_CONFIRMATION_MESSAGE
      </span>
    </div>
    <div class="modal-display-footer">
      <ukg-button-group>
        <ukg-button emphasis="mid" (click)="sendPrenoteConfirmationModal.dismiss()" data-automation="send-prenote-cancel" translate>
          COMMON.BUTTON_CANCEL
        </ukg-button>
        <ukg-button (click)="onSubmit()" data-automation="send-prenote-modal-btn" data-automation="send-prenote-submit" translate>
          COMMON.BUTTON_SUBMIT          
        </ukg-button>        
      </ukg-button-group>
    </div>
  </ng-template>
</ukg-modal>
